<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="breadcrumbs" />
        <h1 class="page-title">Codes Superviseur</h1>
        <p class="page-subtitle">{{ rows.length }} code{{ rows.length > 1 ? 's' : '' }}</p>
      </div>
      <v-btn color="primary" depressed @click="openNew">
        <v-icon left small>mdi-plus</v-icon>
        Nouveau code
      </v-btn>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <v-alert type="info" text dense class="mb-3" style="font-size: 0.8125rem;">
        Les codes superviseur sont requis pour modifier ou supprimer des articles sur une commande de table depuis l'application.
      </v-alert>

      <v-card flat class="table-card">
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">LABEL</th>
              <th class="text-left">CODE</th>
              <th class="text-center">STATUT</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in rows" :key="c.id">
              <td class="text-left font-weight-medium">{{ c.label }}</td>
              <td class="text-left">
                <code class="pa-1" style="background: #f1f5f9; border-radius: 4px;">{{ showCode ? c.code : '••••••' }}</code>
                <v-btn icon x-small @click="showCode = !showCode" class="ml-1">
                  <v-icon x-small>{{ showCode ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </v-btn>
              </td>
              <td class="text-center">
                <v-chip x-small :color="c.active ? 'success' : 'error'" dark>{{ c.active ? 'Actif' : 'Inactif' }}</v-chip>
              </td>
              <td class="text-right" style="white-space:nowrap;">
                <v-btn icon x-small @click="edit(c)" title="Modifier" class="mr-1">
                  <v-icon small color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon x-small @click="confirmDelete(c)" title="Supprimer">
                  <v-icon small color="error">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="rows.length === 0">
              <td colspan="4" class="text-center text--secondary pa-6">Aucun code superviseur. Créez-en un pour sécuriser les modifications de commandes.</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>

    <!-- Create/Edit dialog -->
    <v-dialog v-model="dialog" max-width="420" @click:outside="close">
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">
          <v-icon color="primary" size="18" class="mr-2">{{ index > -1 ? 'mdi-pencil' : 'mdi-plus-circle' }}</v-icon>
          {{ form_title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-body">
          <div class="form-group">
            <label class="form-label">Label *</label>
            <v-text-field v-model="item.label" outlined dense hide-details="auto" placeholder="Ex: Manager, Superviseur"></v-text-field>
          </div>
          <div class="form-group">
            <label class="form-label">Code *</label>
            <v-text-field v-model="item.code" outlined dense hide-details="auto" placeholder="Ex: 1234" :type="showCodeInput ? 'text' : 'password'" :append-icon="showCodeInput ? 'mdi-eye-off' : 'mdi-eye'" @click:append="showCodeInput = !showCodeInput"></v-text-field>
          </div>
          <div class="form-group">
            <v-switch v-model="item.active" :label="item.active ? 'Actif' : 'Inactif'" dense hide-details></v-switch>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="close">Annuler</v-btn>
          <v-btn color="primary" depressed :loading="loading" @click="save" :disabled="!item.label || !item.code">
            {{ index > -1 ? 'Modifier' : 'Créer' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete confirmation -->
    <v-dialog v-model="deleteDialog" max-width="350">
      <v-card>
        <v-card-title class="text-h6">Supprimer ce code ?</v-card-title>
        <v-card-text>Cette action est irréversible.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Annuler</v-btn>
          <v-btn color="error" depressed @click="deleteItem">Supprimer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PreloaderComponent from '../components/PreloaderComponent.vue'
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'

export default {
  name: 'SupervisorCodesView',
  components: { PreloaderComponent, BreadcrumbComponent },
  data: () => ({
    index: -1,
    loading: false,
    dialog: false,
    deleteDialog: false,
    enable: false,
    showCode: false,
    showCodeInput: false,
    rows: [],
    item: { label: 'Superviseur', code: '', active: true },
    deleteTarget: null,
    form_title: 'Nouveau Code',
    store_id: null,
    breadcrumbs: [
      { text: 'Compte', disabled: true },
      { text: 'Codes Superviseur', disabled: false },
    ],
  }),
  methods: {
    load() {
      this.$axios.get('/supervisor-codes?orderasc=label')
        .then(r => { this.rows = r.data; this.enable = true })
        .catch(e => { console.error(e); this.enable = true })
    },
    openNew() { this.reset(); this.dialog = true },
    edit(item) {
      this.index = this.rows.indexOf(item)
      this.item = Object.assign({}, item)
      this.form_title = 'Modifier : ' + this.item.label
      this.dialog = true
    },
    save() {
      if (!this.item.label || !this.item.code) return
      this.loading = true
      var self = this
      this.item.store_id = this.store_id

      if (this.index > -1) {
        this.$axios.put('/supervisor-codes/' + this.item.id + '?data=' + encodeURIComponent(JSON.stringify(self.item)))
          .then(function (r) {
            Object.assign(self.rows[self.index], r.data)
            self.dialog = false; self.loading = false
            self.flashMessage.success({ title: 'Succès', message: 'Code modifié' })
            self.reset()
          }).catch(function () { self.loading = false })
      } else {
        this.$axios.post('/supervisor-codes?data=' + encodeURIComponent(JSON.stringify(self.item)))
          .then(function (r) {
            self.rows.push(r.data)
            self.dialog = false; self.loading = false
            self.flashMessage.success({ title: 'Succès', message: 'Code créé' })
            self.reset()
          }).catch(function () { self.loading = false })
      }
    },
    confirmDelete(item) { this.deleteTarget = item; this.deleteDialog = true },
    deleteItem() {
      if (!this.deleteTarget) return
      var self = this
      this.$axios.delete('/supervisor-codes/' + this.deleteTarget.id)
        .then(function () {
          self.rows = self.rows.filter(r => r.id !== self.deleteTarget.id)
          self.deleteDialog = false; self.deleteTarget = null
          self.flashMessage.success({ title: 'Succès', message: 'Code supprimé' })
        })
    },
    close() { this.dialog = false; this.reset(); this.loading = false },
    reset() { this.item = { label: 'Superviseur', code: '', active: true }; this.index = -1; this.form_title = 'Nouveau Code' },
    getStore() {
      try {
        var business_id = JSON.parse(localStorage.business).id
        var self = this
        this.$axios.get('/stores?business_id=' + business_id)
          .then(function (r) { if (r.data && r.data.length > 0) self.store_id = r.data[0].id })
      } catch (e) { /* ignore */ }
    },
  },
  mounted() { this.load(); this.getStore() },
}
</script>

<style scoped>
.table-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important; overflow: hidden; }
.table-card .v-simple-table thead th { font-size: 0.6875rem !important; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: #94a3b8 !important; border-bottom: 1px solid #e8ecf1 !important; padding: 8px 16px !important; }
.table-card .v-simple-table tbody td { font-size: 0.8125rem; padding: 10px 16px !important; border-bottom: 1px solid #f1f5f9 !important; }
.dialog-card { border-radius: 12px !important; }
.dialog-title { font-size: 0.9375rem !important; font-weight: 600 !important; padding: 14px 20px 12px !important; }
.dialog-body { padding: 20px 20px 8px !important; }
.dialog-actions { padding: 8px 16px 12px !important; }
.form-group { margin-bottom: 16px; }
.form-label { display: block; font-size: 0.75rem; font-weight: 600; color: #475569; margin-bottom: 4px; }
</style>
